import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import looppa from 'looppa';
import reduxUtils from 'util/redux';
import { PRODUCT_LIST_RECOMMMENDATIONS } from 'tracking/constants';
import ProductTile from 'components/product-tile';
import NoSearchHits from '../search-panel-no-hits';
import SearchPanelHeader from '../search-panel-header';
import { t } from 'translations';

class SearchPanelFavoriteProductList extends Component {
    static propTypes = {
        favoriteProducts: PropTypes.array.isRequired,
        populateFavoriteProducts: PropTypes.func.isRequired,
    };

    state = {
        isLoading: true,
    };

    componentDidMount() {
        this.props.populateFavoriteProducts().then(() => {
            if (!this._isUnmounted) {
                this.setState({ isLoading: false });
            }
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.isLoading === nextState.isLoading) {
            return false;
        }

        return true;
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    _isUnmounted = false;

    render() {
        const { favoriteProducts } = this.props;
        const { isLoading } = this.state;
        return (
            <div>
                <SearchPanelHeader title={`${ t('search.personalized_products_title') }`} isLoading={isLoading}/>
                <div className="search-panel-favorite-product-list">
                    {favoriteProducts.length > 0 || isLoading ? (
                        <div>
                            <ul className="search-panel-favorite-product-list--collection u-reset">
                                {looppa(favoriteProducts)((item, i) => (
                                    <li className="search-panel-favorite-product-list--item" key={item.id}>
                                        <ProductTile
                                            {...item}
                                            skipTests={true}
                                            facet="list"
                                            position={i}
                                            list={PRODUCT_LIST_RECOMMMENDATIONS}/>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <NoSearchHits/>
                    )}
                </div>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        favoriteProducts: 'user.favoriteProducts',
    }),
    reduxUtils.mapDispatchToProps({
        populateFavoriteProducts: 'user.populateFavoriteProducts',
    }),
)(SearchPanelFavoriteProductList);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/search/search-panel-favorite-product-list/index.js